import './grid.css';

import './img/blank.png';
import './img/gradient-star.svg';
